export const sale_email = "sales@ooca.co";


// WEBPACK FOOTER //
// ./src/i18n/locales/share.js